import {handleActions} from 'redux-actions';
import {Record} from 'immutable';

import * as HolidayRSVPActions from 'web-app/react/profile/child-profile/holiday-rsvp/actions';

import * as Actions from './actions';

const State = Record({
    show: false,
    vacationId: undefined,
    childId: undefined,
});

export default handleActions(
    {
        [Actions.show.type]: (state, {payload}) =>
            state.merge({
                show: true,
                vacationId: payload.vacationId,
                childId: payload.childId,
            }),
        [Actions.hide.type]: () => new State(),
        [HolidayRSVPActions.updateSuccess.type]: () => new State(),
        [HolidayRSVPActions.fetchAborted.type]: () => new State(),
    },
    new State(),
);
